
<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent>
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->

      <div class="vx-row mb-6">
        <div class="vx-col w-full">

          <span>Selecione a Área:</span>
          <v-select
            :options="areas"
            name="Areas"
            id="Areas"
            v-model="area"
            v-validate="{ required: true}"
            :state="validateState('Area')"
            :class="validateClass('Area')"
          ></v-select>
        </div>

        <div class="vx-col w-full mt-5">
          <span>Selecione o Setor:</span>
          <v-select
            :options="setores"
            name="Setor"
            id="Setor"
            v-model="setor"
            v-validate="{ required: true}"
            :state="validateState('Setor')"
            :class="validateClass('Setor')"
            :disabled="setores.length < 1"
          ></v-select>
        </div>

        <div class="vx-col w-full mt-5">
          <span>Digite o Assunto:</span>
          <vs-input
              size="large"
              class="w-full"
              label-placeholder="Assunto"
              name="Assunto"
              id="Assunto"
              v-model="formCadastro.assunto"
              v-validate="{ required: true }"
              :state="validateState('Assunto')"
              :danger="validateClass('Assunto')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />        
        </div>

        <div class="vx-col w-full mt-5">
          <span>Digite a Mensagem:</span>
          <vs-textarea 
            label="Descreva brevemente sua mensagem aqui.." 
            v-model="formCadastro.mensagem"
            name="Mensagem"
            v-validate="{ required: true }"      
            :state="validateState('Mensagem')"
            :danger="validateClass('Mensagem')" 
          />       
        </div>

        <div class="vx-col w-full mt-5">
          <!-- <center>
            <img :src="formCadastro.logo" />
          </center> -->
          <input id="fileUpload" type="file" hidden v-on:change="selecionaImagens" />
          <vs-button
            color="warning"
            type="border button"
            class="vs-lg-12"
            @click="chooseFiles()"
          >
            Adicionar Imagens
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <div v-if="files.length > 0">
              <vs-chip v-for="item in files" :key="item[0].name" class="mt-3">
                <vs-avatar icon-pack="feather" icon="icon-file" />
                <span>{{ item[0].name }}</span>
              </vs-chip>
            </div>
          </vs-button>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length >0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height:auto !important"
      >
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">{{ error }}</li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>          
          <vs-button color="success" style="margin-left: 1%" class="mt-2 mb-2" @click="novoChamado">Cadastrar</vs-button>
          <!-- <BotaoSubmit
            variant="success"
            :edit="this.dados.idChamado==null?false:true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit> -->
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import locale from "./../../locale";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import swal from "sweetalert";
import vSelect from "vue-select";
import cpfCnpj from "../../services/cpfCnpj";
import service from "../../services";
import BotaoSubmit from "../../components/BotaoSubmit";
import jwt from "jsonwebtoken";

export default {
  props: {
    sideBar: {
      type: Boolean
    },
    dados: {
      type: Object
    }
  },
  watch: {
    area(value) {
      console.log(value);
      this.formCadastro.idArea = value.id;
      this.formCadastro.idSetor = null;
      if(value != null) {
        this.buscaDadosSelectsSetores(
          "domSetor",
          "setores",
          "nomeSetor",
          "idSetor"
        );
      } else { this.setores = [] }
    }
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      areas: [],
      area: null,
      setores: [],
      setor: null,
      file: new FormData(),
      files: [],
      paths: [],

      languages: lang,
      formCadastro: {
        idChamado: null,
        idEmpresa: null,
        idUsuario: null,
        idArea: null,
        idSetor: null,
        assunto: "",
        mensagem: "",
        pathFiles: [],
        idStatus: null
      }
    };
  },
  created: function() {
    // this.$watch("formCadastro", this.formUpdated, {
    //   deep: true
    // });
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    novoChamado() {
      this.formCadastro.idEmpresa = this.idEmpresa;
      this.$validator.validateAll().then(result => {
        if (result) {
          // this.aguardeCadastro = true;
          var user = this.buscaUsuario();
          if(!user) {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: `Problemas ao Buscar o Usuário`,
              color: "danger"
            });
            return
          }
          this.formCadastro.idUsuario = user.id;
          this.formCadastro.email = user.email;
          this.formCadastro.idSetor = this.setor.id;
          this.$vs.loading();
          service
            .post("Chamado", `InserirChamado`, this.formCadastro)
            .then(res => {
              console.log(res);
              // this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success"
              });
              this.$emit("concluido");
              this.$vs.loading.close();
            })
            .catch(error => {
              // this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger"
              });
              this.$vs.loading.close();
            });
        }
      });
    },
    
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then(res => {
        res.data.forEach(element => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao]
          });
        });
      });
    },
    resetForm() {
      this.formCadastro = {
        idChamado: null,
        idEmpresa: null,

        idArea: null,
        idSetor: null,
        assunto: "",
        mensagem: "",
        pathFotos: [],
        idStatus: null
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit("cancel");
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },    
    buscaDadosSelectsSetores(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll("g", {}, `${model}/list/idArea/${this.formCadastro.idArea}`)
        .then(res => {
          res.data.forEach(element => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao]
            });
          });

          this.$vs.loading.close();
        });
    },
    selecionaImagens(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.file.set("file", event.target.files[0], event.target.files[0].name);
      this.files.push(files);
      this.paths.push(this.file);
      //this.nomeLogo = event.target.files[0].name;

      this.$vs.loading();
      var that = this;
      service
      .upload("Upload", "chamado/" + "idEmpresa=null", this.file)
      .then(response => {
        console.log(response);
        that.formCadastro.pathFiles.push(response);
        that.$vs.loading.close();
      })
      .catch(function(error) {
        that.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: error,
          color: "danger"
        });
        that.$vs.loading.close();
      });
    },    
    chooseFiles() {
      document.getElementById("fileUpload").click();
    },    
    buscaUsuario() {
      const token = localStorage.getItem("user-token");
      if (token) {
        const decoded = jwt.decode(token);
        return { id: decoded.id_usuario, email: decoded.email };
      }else{
        return null
      }
    },
  },
  mounted() {
    this.buscaDadosSelects("domArea", "areas", "nomeArea", "idArea");
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect
  }
};
</script>
<!------------ END SCRIPT ------------>
